import { useQuery } from '@tanstack/react-query';

import { useLocale } from 'next-intl';
import { useParams } from 'next/navigation';

import { MovieApi } from '@/api/domains/movie.api';

import { MovieQueryKeys } from '@/contexts/QueryContext/query.keys';

export const useRelatedMovies = () => {
  const locale = useLocale();

  const { moduleId, movieId } = useParams() as { moduleId: string; movieId: string };

  const { data = [], isLoading } = useQuery({
    queryKey: MovieQueryKeys.relatedMovies(moduleId, movieId, locale),
    queryFn: () => MovieApi.fetchRelatedMovies({ module_id: moduleId, id: movieId }),
    staleTime: Infinity,
  });

  return { movies: data, isLoading };
};
